export default __webpack_public_path__ + "static/media/map-middle.0833b743.jpg";